import { ColumnType } from 'antd/lib/table';

import { TTariffGrid } from '../../core/tariff-grid';
import { createDataMapTariff } from './create-data-map-tariff';
import { TariffPriceCell } from './tariff-price-cell';

import styles from './data-grid.module.css';

export type DataGridTariffRow = {
  trainTypeId: number;
  tariffTypeId: number;
  tariffTypeName: string;
};

export const createTableGridData = (data: TTariffGrid) => {
  const dataMap = createDataMapTariff(data);
  const trainTypesMap = Object.fromEntries(
    data.trainTypes.map((item) => [item.id, item]),
  );

  const tariffTypesRows = data.trainTypes
    .reduce<DataGridTariffRow[]>((acc, trainType) => {
      const tariffsWithTrainType = data.tariffTypes.map((tariffType) => ({
        trainTypeId: trainType.id,
        tariffTypeId: tariffType.id,
        tariffTypeName: tariffType.nameRu,
      }));

      return acc.concat(tariffsWithTrainType);
    }, [])
    .sort((a, b) => {
      if (a.trainTypeId === b.trainTypeId) {
        return a.tariffTypeId - b.tariffTypeId;
      }

      return a.trainTypeId - b.trainTypeId;
    });

  const firstTariffTypeId = [...data.tariffTypes].sort((a, b) => a.id - b.id)[0]
    .id;

  const trainTypesCol: ColumnType<DataGridTariffRow> = {
    title: 'Тип состава',
    key: 'trainType',
    width: '1%',
    onCell: (row) => {
      // rows should be sorted by data.trainTypeId, then data.tariffId
      if (row.tariffTypeId === firstTariffTypeId) {
        return { rowSpan: data.tariffTypes.length };
      }

      return {
        rowSpan: 0,
      };
    },
    render: (_: any, row: { trainTypeId: number }) => {
      return trainTypesMap[row.trainTypeId].nameRu;
    },
  };

  const zoneCols: ColumnType<DataGridTariffRow>[] = data.tariffZones.map(
    (zone) => {
      return {
        title: zone.nameRu,
        key: `zone-${zone.id}`,
        width: '1%',
        onCell: (row) => {
          return {
            className: styles.cell,
            row, // pass row data for custom "GridCellComponent" component (for antd/<Table/> ). Used for find tariff in DataMap
            zoneId: zone.id,
          };
        },
        render: (_: any, row) => {
          return <TariffPriceCell row={row} zoneId={zone.id} />;
        },
      };
    },
  );

  const tariffsCol: ColumnType<DataGridTariffRow> = {
    width: '1%',
    title: 'Виды тарифов',
    dataIndex: 'tariffTypeName',
  };

  const cols = [trainTypesCol, tariffsCol, ...zoneCols];
  const rows = tariffTypesRows;

  return { cols, rows, dataMap };
};

export type TariffTableGridData = ReturnType<typeof createTableGridData>;
